import {computed} from 'vue';
import {useState} from '#imports';
import type {Skill} from '~/openapi';
import {SkillTypeEnum} from '~/openapi';
import {useSkillSetStore} from '~/store/skill-set/skillSetStore';

export function useSkillSetState() {
    const currentSelectedSkills = useState<Skill[]>('state-profile-edition-selected-skills', () => []);
    const currentTopSkills = useState<Skill[]>('state-profile-edition-top-skills', () => []);

    const currentTopFunctionalSkills = computed(() => currentTopSkills.value.filter((topSkill) => topSkill.type === SkillTypeEnum.Functional));
    const currentRemainingFunctionalSkills = computed(() =>
        currentSelectedSkills.value.filter((selectedSkill) => selectedSkill.type === SkillTypeEnum.Functional),
    );
    const currentTopAndRemainingFunctionalSkills = computed(() => [...currentTopFunctionalSkills.value, ...currentRemainingFunctionalSkills.value]);

    const currentGlobalSkillsAddedToSelectedSkills = computed(() =>
        currentSelectedSkills.value.filter((selectedSkill) => selectedSkill.type === SkillTypeEnum.Global),
    );
    const currentGlobalSkillsAddedToTopSkills = computed(() => currentTopSkills.value.filter((topSkill) => topSkill.type === SkillTypeEnum.Global));

    const currentGlobalSkills = computed(() => [...currentGlobalSkillsAddedToTopSkills.value, ...currentGlobalSkillsAddedToSelectedSkills.value]);

    function addSelectedSkill(skillToAdd: Skill) {
        currentSelectedSkills.value.push(skillToAdd);
    }
    function addTopSkill(skillToAdd: Skill) {
        currentTopSkills.value.push(skillToAdd);
    }
    function removeSelectedSkill(skillToRemove: Skill) {
        currentSelectedSkills.value = currentSelectedSkills.value.filter((selectedSkill) => selectedSkill.id !== skillToRemove.id);
    }
    function removeTopSkill(skillToRemove: Skill) {
        currentTopSkills.value = currentTopSkills.value.filter((topSkill) => topSkill.id !== skillToRemove.id);
    }

    function initializeStateUsingStoreValues() {
        const {profileSelectedSkills, profileTopSkills} = useSkillSetStore();

        currentSelectedSkills.value = [...profileSelectedSkills];
        currentTopSkills.value = [...profileTopSkills];
    }

    return {
        currentTopAndRemainingFunctionalSkills,
        currentGlobalSkillsAddedToSelectedSkills,
        currentRemainingFunctionalSkills,
        currentGlobalSkills,
        currentSelectedSkills,
        currentTopSkills,
        addSelectedSkill,
        addTopSkill,
        removeSelectedSkill,
        removeTopSkill,
        initializeStateUsingStoreValues,
    };
}
